import React, { useEffect, useState } from "react";
import AverageBarGraph from "../../CHARTS/AverageBarGraph";
import { RiResetLeftFill } from "react-icons/ri";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import LineRaceChart from "../../CHARTS/LineRaceChart";
import {
  buildSunburstData,
  getDaysInMonth,
  sumArrayOfObjects,
} from "../../Utilitie";
import SunburstChart from "../../CHARTS/SunburstChart";

const CrewHQGraph = ({
  data,
  selectedBar,
  setSelectedLineBar,
  setSunBurstChartData,
}) => {
  const tempLobbyWise = sumArrayOfObjects(data, ["hq_lobby"], [], "group");
  const chartDataLobbyWise = tempLobbyWise.map((o) => ({
    time: o.group,

    // Keep numeric safe value
    "Occurence at Lobby": Number(o.hq_occurence || 0),

    // Average per month (similar to MonthWise Avg logic)
    "Avg value": Number(o.hq_occurence / (tempLobbyWise.length || 1)).toFixed(
      2,
    ),

    // Overall lobby average (like your MonthWise "Avg")
    Avg: (
      tempLobbyWise.reduce((sum, acc) => {
        return sum + Number(acc.hq_occurence || 0);
      }, 0) / (tempLobbyWise.length || 1)
    ).toFixed(2),
  }));

  // console.log(chartDataLobbyWise);

  const [selectedLobby, setSelectedLobby] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");

  /* ---------------------------------------------
   * Extract selection (same pattern you use)
   * ------------------------------------------- */
  const getLobbyObject = (selectedBar) => {
    return selectedBar?.find((item) => "lobby" in item)?.lobby || "";
  };

  const getMonthObject = (selectedBar) => {
    return selectedBar?.find((item) => "month" in item)?.month || "";
  };

  useEffect(() => {
    setSelectedLobby(getLobbyObject(selectedBar));
    setSelectedMonth(getMonthObject(selectedBar));
  }, [selectedBar]);

  /* ---------------------------------------------
   * Apply filters
   * ------------------------------------------- */

  const filteredData =
    selectedLobby === ""
      ? data
      : data.filter((o) => o.hq_lobby === selectedLobby);

  const tempMonthWise = sumArrayOfObjects(
    filteredData,
    ["hq_month", "hq_year"],
    ["hq_month"],
    "group",
  );
  const chartDataMonthWise = tempMonthWise.map((o) => ({
    month: o.hq_month,
    value: Number(o.hq_occurence || 0),
    "Avg value": Number(
      o.hq_occurence / getDaysInMonth(`${o.hq_year}`, o.hq_month),
    ).toFixed(2),
    Avg: (
      tempLobbyWise.reduce((sum, acc) => {
        return sum + acc.hq_occurence;
      }, 0) / tempMonthWise.length
    ).toFixed(2),
  }));

  useEffect(() => {
    const a = buildSunburstData(filteredData, {
      layers: ["hq_lobby"],
      leafNameKey: "hq_crew_lobby",
      leafValueKey: "hq_occurence",
      leafTextKey: "hq_occurence",
    });
    setSunBurstChartData(a);
  }, [filteredData]);
  return (
    <div>
      <div className="row mt-2">
        <div className="col-md-6">
          <div className="newUiBody ">
            <h5 className="bg-dark text-white ">Lobby Wise Occurrence</h5>
            {/* <LineRaceChart
              data={chartDataLobbyWise}
              setSelectedLineBar={setSelectedLineBar}
              barName={"lobby"}
              height={450}
            /> */}
            <AverageBarGraph
              id="chart-1"
              data={chartDataLobbyWise}
              categoryKey="time"
              barKeys={[
                {
                  key: "Occurence at Lobby",
                  name: "Occurrence",
                  yAxisIndex: 0,
                  color: "#5070dd",
                  unit: "",
                },
              ]}
              lineKeys={[
                {
                  key: "Occurence at Lobby",
                  name: "Occurrence Trend",
                  yAxisIndex: 1,
                  color: "#505372",
                  unit: "",
                },
                {
                  key: "Avg",
                  name: "Occurrence Avg",
                  yAxisIndex: 1,
                  color: "#e64b0e",
                  unit: "",
                },
              ]}
              height={300}
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="newUiBody ">
            <h5 className="bg-dark text-white ">Month Wise Occurrence</h5>
            <AverageBarGraph
              id="chart-1"
              data={chartDataMonthWise}
              categoryKey="month"
              barKeys={[
                {
                  key: "value",
                  name: "Occurrence",
                  yAxisIndex: 0,
                  color: "#5070dd",
                  unit: "",
                },
              ]}
              lineKeys={[
                {
                  key: "value",
                  name: "Occurrence Trend",
                  yAxisIndex: 1,
                  color: "#505372",
                  unit: "",
                },
                {
                  key: "Avg",
                  name: "Occurrence Avg",
                  yAxisIndex: 1,
                  color: "#e64b0e",
                  unit: "",
                },
              ]}
              height={300}
            />
          </div>
        </div>

        {/* <div>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Reset Lobby</Tooltip>}
          >
            <button
              className="btn btn-sm btn-outline-danger me-1"
              onClick={() => setSelectedLobby("")}
            >
              <RiResetLeftFill />
            </button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Reset Month</Tooltip>}
          >
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => setSelectedMonth("")}
            >
              <RiResetLeftFill />
            </button>
          </OverlayTrigger>
        </div> */}
      </div>

      {/*  This is the key part */}
    </div>
  );
};

export default CrewHQGraph;
